export default {
  label: {
    createAcct: 'founder',
    createTime: 'Creation time',
    merchantNo: 'business number',
    updateAcct: 'updater',
    updateTime: 'Update time',
    walletAmount: 'Wallet amount',
    walletType: 'wallet type',
    momo: 'Momo',
    zalo: 'Zalo',
    vtp: 'Viettel pay',
    vtpFix: 'Viettel pay fix',
    bankOnline: 'Bank online',
    transfer: 'Bank transfer',
    bankQr: 'Bank QR',
    all: 'All',
    card: 'Card',
    payout: 'Payout',
    allMerchantBalance: '商户总余额',
    todayPayoutAmount: '今日交易金额',
    todayBalanceAmount: '出款金额',
    todayTradeAmount: '余额',
    yesterdayTradeAmount: '昨日交易金额',
    usdtBalance: 'usdt wallet'
  },
  rules: {
    walletType: 'The wallet type cannot be empty!'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/merchantBalance.js